import Link from '@material-ui/core/Link'
import { Stack } from 'components/Stack'
import { CopyText, CopyWrapper } from './DiscountBanner.styles'

type DiscountBannerCopyProps = {
  primaryText: string
  disableClickPages: boolean
  secondaryText: string
}

export const DiscountBannerCopy = (params: DiscountBannerCopyProps) => {
  const { primaryText, disableClickPages, secondaryText } = params

  const content = (
    <CopyWrapper
      direction="row"
      justifyContent="center"
      alignItems="center"
      gap="0"
      clickable={!disableClickPages}
    >
      {primaryText ? (
        <Stack direction={{ '@initial': 'column', '@bp3': 'row' }} gap="0">
          <CopyText>{primaryText}</CopyText>
          {secondaryText ? (
            <>
              <CopyText css={{ display: 'none', '@bp3': { display: 'inline' } }}>&nbsp;</CopyText>
              <CopyText>{secondaryText}</CopyText>
            </>
          ) : null}
        </Stack>
      ) : (
        <Stack direction={{ '@initial': 'column', '@bp3': 'row' }} gap="0">
          <CopyText>Free Shipping with Every Box!</CopyText>
        </Stack>
      )}
    </CopyWrapper>
  )

  return disableClickPages ? (
    content
  ) : (
    <Link href="/meal-plan" css={{ display: 'flex', width: '100%' }}>
      {content}
    </Link>
  )
}
